import * as React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

interface Props {
  btnMessage: string;
  message: string;
  messageDetail: string | null;
  onClose: () => void;
  onSubmit: () => void;
}

class AlertDialog extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { btnMessage, message, messageDetail, onClose, onSubmit } = this.props;
    return (
      <div>
        <Dialog
          open={message.length > 0}
          onClose={onClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{message}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {messageDetail}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} color="primary">
              キャンセル
            </Button>
            <Button onClick={onSubmit} color="primary" autoFocus>
              {btnMessage}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default AlertDialog;



// WEBPACK FOOTER //
// ./src/components/AlertDialog.tsx